import React, { useState } from 'react';
import { Router } from '@reach/router';
import { connect } from '../../redux/store';
import { DatastoreSubmission } from './Submission';
import { FormList } from './FormList';
import { SubmissionSearch } from './SubmissionSearch/SubmissionSearch';
import { DatastoreSettings } from './DatastoreSettings';
import { TableComponents } from '@kineticdata/bundle-common';

const tableKey = 'datastore-list';

export const DatastoreRouter = ({ loading }) => {
  const [pageSize, setPageSize] = useState(25);
  return (
    !loading && (
      <Router>
        <TableComponents.MountWrapper tableKey={tableKey} default>
          <SubmissionSearch path=":slug" />
          <DatastoreSettings tableKey={tableKey} path=":slug/settings" />
          <DatastoreSubmission path=":slug/new" />
          <DatastoreSubmission path=":slug/:id" />
          <FormList
            tableKey={tableKey}
            pageSize={pageSize}
            setPageSize={setPageSize}
            default
          />
        </TableComponents.MountWrapper>
      </Router>
    )
  );
};

export const mapStateToProps = state => ({
  loading: state.settingsDatastore.loading,
});

export const Datastore = connect(mapStateToProps)(DatastoreRouter);
